/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Modal, ModalProps, Tabs } from 'antd';
import { useIntl } from 'react-intl';
import ModuleTenderHammerNoColor from '~src/assets/nav-icons/folder-tender-hammer-no-color.svg';
import { NavIcon } from '~components/_common/NavIcon/NavIcon';
import { useEffect, useRef, useState } from 'react';
import {
  ContractorEditTab,
  ContractorEditTabRef,
} from './tabs/ContractorEditTab';
import { ContactSettingsTab } from './tabs/ContactSettingsTab';

const { TabPane } = Tabs;

export const ContractorModalWindow = ({
  item,
  ...props
}: Pick<ModalProps, 'visible' | 'onOk' | 'onCancel'> & {
  item: {
    title: string | undefined;
    reference?: string;
    projectId?: string;
    tenderId?: string;
    orderGiver?: {
      contactor_title?: string;
      contactor_subtitle?: string;
    };
    location?: {
      location_1?: string;
      location_2?: string;
    };
    contractorCompany?: string;
    contact?: string[];
  };
}) => {
  const intl = useIntl();
  const contractorRef = useRef<ContractorEditTabRef | null>(null);

  const [activeTab, setActiveTab] = useState<'contractor' | 'contacts'>(
    'contractor'
  );
  const [contractorLoading, setContractorLoading] = useState(false);

  const wasVisibleRef = useRef(props.visible);

  // reset to first tab when modal opens
  useEffect(() => {
    if (props.visible && !wasVisibleRef.current) {
      setActiveTab('contractor');
    }
    wasVisibleRef.current = props.visible;
  }, [props.visible]);

  const Title = () => (
    <div>
      <NavIcon
        customStyle={{ width: '45px', height: '22px' }}
        icon={ModuleTenderHammerNoColor}
      />
      {intl.formatMessage({ id: 'tender-details-edit-contractor' })}
    </div>
  );

  const isContractorTab = activeTab === 'contractor';
  const modalWidth = activeTab === 'contacts' ? 1100 : 500;

  return (
    <Modal
      title={<Title />}
      visible={props.visible}
      width={modalWidth}
      maskClosable={false}
      confirmLoading={isContractorTab ? contractorLoading : false}
      okText={isContractorTab ? intl.formatMessage({ id: 'save' }) : undefined}
      onOk={
        isContractorTab ? () => contractorRef.current?.handleSave() : undefined
      }
      onCancel={props.onCancel}
      footer={isContractorTab ? undefined : null}>
      <Tabs activeKey={activeTab} onChange={(k) => setActiveTab(k as any)}>
        <TabPane
          key="contractor"
          tab={intl.formatMessage({ id: 'tender-details-edit-contractor' })}>
          <ContractorEditTab
            ref={contractorRef}
            visible={props.visible}
            item={item}
            onLoadingChange={setContractorLoading}
            onOk={() => {
              props.onOk &&
                props.onOk(
                  (null as unknown) as React.MouseEvent<HTMLElement, MouseEvent>
                );
            }}
          />
        </TabPane>

        <TabPane
          key="contacts"
          tab={intl.formatMessage({ id: 'project-contacts-settings' })}>
          <ContactSettingsTab
            active={props.visible && activeTab === 'contacts'}
            projectIdOverride={item.projectId}
          />
        </TabPane>
      </Tabs>
    </Modal>
  );
};
